import { useState, useEffect } from "react";

// Manage the timer centrally to avoid duplicates
let intervalId = null;
let intervalRefCounter = 0;

const useOsmosisPoolData = () => {
  const [osmosisPoolData, setOsmosisPoolData] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(
          "https://api-osmosis.imperator.co/stream/pool/v1/1721"
        );
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        const jsonData = await response.json();

        const sqrtPrice = parseFloat(jsonData.current_sqrt_price);
        const price = sqrtPrice * sqrtPrice;

        const amountLibra = jsonData.pool_tokens.asset0.amount;
        const amountUSDC = jsonData.pool_tokens.asset1.amount;

        setOsmosisPoolData({
          price: price,
          volume_24h: null,
          wLibraAmount: amountLibra,
          usdcAmount: amountUSDC,
          liquidity: amountLibra * price + amountUSDC,
        });
      } catch (error) {
        console.error("Failed to fetch Osmosis pool data:", error);
      }
    };

    // Start fetching data at regular intervals if it's the first component instance
    if (intervalRefCounter === 0) {
      intervalId = setInterval(fetchData, 30000); // Fetch data every 30 seconds
    }
    intervalRefCounter += 1;

    // Fetch data immediately on mount
    fetchData();

    // Cleanup function to clear interval when no components need it
    return () => {
      intervalRefCounter -= 1;
      if (intervalRefCounter === 0 && intervalId !== null) {
        clearInterval(intervalId);
        intervalId = null;
      }
    };
  }, []);

  return osmosisPoolData;
};

export default useOsmosisPoolData;
